import InfiniteList from 'components/InfiniteList'
import { useListCollectiveMembers } from 'hooks/collectives/useListCollectiveMembers'
import CollectiveMemberListItem from './CollectiveMemberListItem'
import { useCollectiveContext } from 'context/CollectiveContext'
import { useEffect, useMemo, useState } from 'react'
import { useCollectiveDemoContext } from 'context/CollectiveDemoContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltLeft } from '@fortawesome/pro-solid-svg-icons'
import CollectivePageHeader from './Common/CollectivePageHeader/CollectivePageHeader'
import ContentWrapper from '../ContentWrapper'
import CollectiveMembersExport from './CollectiveMembersExport'
import SearchInput from './Common/SearchInput'
import { useControlledInput } from 'hooks'
import { useDebouncedCallback } from 'use-debounce'

function CollectiveMembers() {
  const { collective, demoMode } = useCollectiveContext()

  const [search, setSearch] = useState<string>('')
  const [searchString, onSearchStringChange, clearSearchString] =
    useControlledInput()
  const onSearchStringChangeDebounced = useDebouncedCallback(e => {
    setSearch(e)
  }, 300)
  useEffect(() => {
    onSearchStringChangeDebounced(searchString)
  }, [onSearchStringChange, onSearchStringChangeDebounced, searchString])

  const { edges, loadMore, loadingMore, loading } = useListCollectiveMembers(
    collective.id,
    demoMode,
    search
  )

  const { collectiveMembers, setViewingMembers } = useCollectiveDemoContext()

  const members = useMemo(
    () => (demoMode ? collectiveMembers?.edges : edges),
    [collectiveMembers?.edges, demoMode, edges]
  )

  return (
    <ContentWrapper>
      {!demoMode ? (
        <CollectivePageHeader collective={collective} />
      ) : (
        <div
          className="m-4 cursor-pointer flex items-center space-x-2"
          onClick={() => setViewingMembers(false)}
        >
          <FontAwesomeIcon icon={faArrowAltLeft} className="mr-2" /> Go Back To
          Collective
        </div>
      )}

      <div className="flex justify-end my-5 px-6 space-x-2">
        {collective.membership?.privileged && <CollectiveMembersExport />}

        <SearchInput
          searchString={searchString}
          onSearchStringChange={onSearchStringChange}
          clearSearchString={clearSearchString}
          contextText="address"
        />
      </div>

      <InfiniteList
        direction={'grid'}
        className="px-6 py-2"
        items={members}
        loadMore={loadMore}
        loading={loading}
        loadingMore={loadingMore}
        renderItem={edge => (
          <CollectiveMemberListItem key={edge.node.id} member={edge.node} />
        )}
      />
    </ContentWrapper>
  )
}

export default CollectiveMembers
